import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-28 pb-16 lg:pt-36 lg:pb-24 overflow-hidden w-full bg-background" data-id="element-89" data-mp="eiv5avzyr8kb">
      <div className="max-w-7xl mx-auto px-6" data-id="element-90" data-mp="9ll9mylze0o1">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-91" data-mp="4lqictyan92g">
          {/* Left Column: Text Content & Mobile Image */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-92" data-mp="128fo9ew4a5tl">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-primary leading-[1.15]" data-id="element-93" data-mp="xbfmvha7pr8t">
              Кваліфікований юридичний захист у військових справах та питаннях мобілізації
            </motion.h1>

            {/* Mobile Image (Visible only on small screens, between Headline and Description) */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 1,
            ease: 'easeOut',
            delay: 0.2
          }} className="block lg:hidden w-full h-[300px] sm:h-[380px] rounded-[2rem] overflow-hidden shadow-xl my-7" data-id="element-94" data-mp="39acuifmnb6os">
              <img src="https://cdn.magicpatterns.com/uploads/ecMtWPM2pSbX75G35YS4QG/IMG_5141.jpg" alt="Legal Protection" className="w-full h-full object-cover" data-id="element-95" data-mp="2qi0lxb5ef967" />
            </motion.div>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut',
            delay: 0.2
          }} className="mt-6 text-lg sm:text-xl text-secondary leading-relaxed max-w-2xl" data-id="element-96" data-mp="2ljpbozb6ywng">
              Спеціалізуюся на отриманні відстрочок, оскарженні рішень ВЛК та ТЦК, виплатах та правовому супроводі. Захищаю ваші інтереси на кожному етапі.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut',
            delay: 0.3
          }} className="mt-7 lg:mt-8 w-full sm:w-auto" data-id="element-97" data-mp="162lyd08a3vps">
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-98" data-mp="3htpy5s2pykmg">
                <a href="#contact" className="w-full sm:w-auto px-8 py-3.5 bg-primary text-background rounded-full font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity shadow-lg" data-id="element-99" data-mp="21awe8b624vhh">
                  Консультація адвоката
                  <ArrowRight size={18} data-id="element-100" data-mp="2g02jafrktfxa" />
                </a>
                <a href="#services" className="w-full sm:w-auto px-8 py-3.5 bg-surface text-primary rounded-full font-medium hover:bg-border/50 transition-colors border border-border flex items-center justify-center" data-id="element-101" data-mp="2fzj436tb95my">
                  Послуги
                </a>
              </div>
            </motion.div>
          </div>

          {/* Right Column: Desktop Image (Visible only on large screens) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          x: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          x: 0
        }} transition={{
          duration: 1,
          ease: 'easeOut',
          delay: 0.2
        }} className="hidden lg:block w-full h-[500px] rounded-[2.5rem] overflow-hidden shadow-2xl" data-id="element-102" data-mp="zkr8ym4s5k9y">
            <img src="https://cdn.magicpatterns.com/uploads/ecMtWPM2pSbX75G35YS4QG/IMG_5141.jpg" alt="Legal Protection" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" data-id="element-103" data-mp="3hq0sdrjgpk7y" />
          </motion.div>
        </div>
      </div>
    </section>;
}